import React from 'react';
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle";

import './App.css';
import { Routes , Route} from "react-router-dom";

import Home from './Components/Home';
import About from './Components/About';
import Contact from './Components/Contact';
import Services from './Components/Services';
import Navbar from './Components/Navbar';
import Footer from './Components/Footer';


function App() {
  return (
    <div className="App">
      
      <Navbar />
      <Routes>
        <Route path='/' Component={Home}/>
        <Route path='/about' Component={About} />
        <Route path='/contact' Component={Contact} />
        <Route path='/services' Component={Services} />
      </Routes>
      <Footer/>
    </div>
  );
}

export default App;
